import {useAuth} from '@/hooks/useAuth'
import {AuthContext} from './AuthContext'

export const AuthProvider = ({shellActive = false, children}) => {
  const auth = useAuth({shellActive})
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

